function isHlsUrl(url) {
    return url.includes('.m3u8');
}
async function attachSource(video, url) {
    if (!isHlsUrl(url)) {
        video.src = url;
        return;
    }
    // Safari / iOS: native HLS
    if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = url;
        return;
    }
    // Chrome / Firefox / Android: hls.js
    try {
        const { default: Hls } = await import('hls.js');
        if (Hls.isSupported()) {
            const hls = new Hls();
            hls.loadSource(url);
            hls.attachMedia(video);
            video.__hls = hls;
            return;
        }
    }
    catch { /* hls.js not bundled — fall through */ }
    video.src = url;
}
export class VideoRenderer {
    canRender(item) {
        return item.kind === 'video' || item.kind === 'field_video';
    }
    mount(container, item, opts) {
        let destroyed = false;
        const root = document.createElement('div');
        root.style.cssText = 'position:relative;width:100%;height:100%;background:#000;display:flex;align-items:center;justify-content:center;';
        container.appendChild(root);
        const video = document.createElement('video');
        video.style.cssText = 'max-width:100%;max-height:100%;display:block;';
        video.controls = true;
        video.playsInline = true;
        video.muted = true;
        video.autoplay = true;
        if (item.poster_url)
            video.poster = item.poster_url;
        root.appendChild(video);
        const loadUrl = (url) => {
            void attachSource(video, url).catch(() => {
                if (!destroyed)
                    opts.onError?.(new Error('Video source attach failed'));
            });
        };
        if (typeof item.url === 'string') {
            loadUrl(item.url);
        }
        else {
            void item.url().then((u) => { if (!destroyed)
                loadUrl(u); });
        }
        video.addEventListener('loadedmetadata', () => {
            if (!destroyed)
                opts.onReady?.({ is3D: false, hasAudio: true });
        });
        video.addEventListener('error', () => {
            if (!destroyed)
                opts.onError?.(new Error('Video failed to load'));
        });
        return {
            update() { },
            destroy() {
                destroyed = true;
                try {
                    video.pause();
                }
                catch { /* swallow */ }
                const hls = video.__hls;
                if (hls) {
                    hls.destroy();
                }
                video.removeAttribute('src');
                video.load();
                root.remove();
            },
        };
    }
}
//# sourceMappingURL=VideoRenderer.js.map